import { render, staticRenderFns } from "./AxEditable.vue?vue&type=template&id=cf51a2e2&scoped=true&"
import script from "./AxEditable.vue?vue&type=script&lang=ts&"
export * from "./AxEditable.vue?vue&type=script&lang=ts&"
import style0 from "./AxEditable.vue?vue&type=style&index=0&id=cf51a2e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf51a2e2",
  null
  
)

export default component.exports